/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type SubscriptionCustomersTableV2CustomerFragment = { __typename: 'Customer', id: string, name: string, displayCount: number, waveSubscriptionUsage?: number | null, waveSubscriptions?: Array<{ __typename: 'WaveSubscription', id: string, validUntil: any, status: Types.WaveSubscriptionStatus }> | null };

export const SubscriptionCustomersTableV2CustomerFragmentDoc = gql`
    fragment SubscriptionCustomersTableV2Customer on Customer {
  id
  name
  displayCount
  waveSubscriptionUsage
  waveSubscriptions {
    id
    validUntil
    status
  }
  waveSubscriptionUsage
}
    `;